import { connect } from 'react-redux'
import Orders from './Orders'

import componentWillMount from './Handlers/componentWillMount'
import onChangeSelectedRows from './Handlers/onChangeSelectedRows'

const mapStateToProps = (state) => ({
  selectedOrderIds: state.screens.ProjectView.selectedOrderIds,
})

const actionCreators = {
  componentWillMount,
  onChangeSelectedRows,
}

export default connect(mapStateToProps, actionCreators)(Orders)
